import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight } from "lucide-react";
export const HeroSection = () => {
  const scrollToVideo = () => {
    const videoSection = document.getElementById('video-section');
    if (videoSection) {
      videoSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-4 md:py-6 lg:py-8 text-center pb-0">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="text-lg md:text-xl text-brand-teal mb-2 md:mb-4 font-semibold">
          🚀 Aumente seu faturamento em até 40%
        </h2>
        
        <h1 className="md:text-4xl lg:text-6xl font-bold text-gray-900 dark:text-white mb-4 md:mb-6 leading-tight text-2xl">
          {/* Mobile: texto unificado */}
          <span className="md:hidden text-transparent bg-clip-text bg-gradient-to-r from-brand-teal to-brand-coral">
            Potencialize o lucro da sua loja a cada nova venda
          </span>
          
          {/* Desktop: divisão de cores */}
          <span className="hidden md:inline">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-teal to-brand-coral">
              Potencialize o lucro da sua loja
            </span>
            <span className="text-gray-900 dark:text-white block mt-2">
              a cada nova venda
            </span>
          </span>
        </h1>
        
        <p className="text-base md:text-lg lg:text-xl text-gray-600 dark:text-gray-300 mb-8 max-w-4xl mx-auto leading-relaxed px-2">
          Implemente programas de <strong>cashback</strong> e <strong>indicações</strong> que fazem seus clientes venderem para você. 
          Aumente receita, retenção e margem de lucro automaticamente.
        </p>

      </div>
    </section>;
};